import { render, staticRenderFns } from "./mixtureSettings.vue?vue&type=template&id=5d076172"
import script from "./mixtureSettings.vue?vue&type=script&lang=js"
export * from "./mixtureSettings.vue?vue&type=script&lang=js"
import style0 from "./mixtureSettings.vue?vue&type=style&index=0&id=5d076172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports